export enum MessageType {
  ERROR = 'error',
  INFO = 'info',
  LOADING = 'loading',
  SUCCESS = 'success',
  WARNING = 'warning',
}
